// Swiss signature events & gatherings. Text content (all 14 languages) lives in
// eventTranslations.js (EVENT_I18N); this file holds only metadata + images.
// catKey is a stable category key used for filtering (labels are localized in EV_UI).
const IMG = "/images/events/";

export const EVENT_CATS = ["kongress", "festival", "panoramabahn", "kunst", "tradition", "sport"];

export const EVENTS = [
  { slug: "wef-davos", catKey: "kongress", citySlug: "davos", image: IMG + "wef-davos.webp" },
  { slug: "art-basel", catKey: "kunst", citySlug: "basel", image: IMG + "art-basel.webp" },
  { slug: "bernina-express", catKey: "panoramabahn", citySlug: "st-moritz", image: IMG + "bernina-express.webp" },
  { slug: "montreux-jazz", catKey: "festival", citySlug: "montreux", image: IMG + "montreux-jazz.webp" },
  { slug: "locarno-film", catKey: "festival", citySlug: "locarno", image: IMG + "locarno-film.webp" },
  { slug: "lucerne-festival", catKey: "festival", citySlug: "luzern", image: IMG + "lucerne-festival.webp" },
  { slug: "street-parade", catKey: "festival", citySlug: "zurich", image: IMG + "street-parade.webp" },
  { slug: "glacier-express", catKey: "panoramabahn", citySlug: "zermatt", image: IMG + "glacier-express.webp" },
  { slug: "basel-fasnacht", catKey: "tradition", citySlug: "basel", image: IMG + "basel-fasnacht.webp" },
  { slug: "zurich-filmfestival", catKey: "festival", citySlug: "zurich", image: IMG + "zurich-filmfestival.webp" },
  { slug: "verbier-festival", catKey: "festival", citySlug: "verbier", image: IMG + "verbier-festival.webp" },
  { slug: "gstaad-menuhin", catKey: "festival", citySlug: "gstaad", image: IMG + "gstaad-menuhin.webp" },
  { slug: "montreux-comedy", catKey: "festival", citySlug: "montreux", image: IMG + "montreux-comedy.webp" },
  { slug: "zermatt-unplugged", catKey: "festival", citySlug: "zermatt", image: IMG + "zermatt-unplugged.webp" },
  { slug: "white-turf", catKey: "sport", citySlug: "st-moritz", image: IMG + "white-turf.webp" },
];

export const EVENT_BY_SLUG = Object.fromEntries(EVENTS.map((e) => [e.slug, e]));
